<section
  class="relative bg-[url('https://images.unsplash.com/photo-1725623851398-45ca8236a95b?q=80&w=1466&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')] bg-cover bg-center bg-no-repeat"
>
  <div class="absolute inset-0 bg-white/50"></div>

  <div class="relative mx-auto max-w-screen-xl px-4 py-32 sm:px-6 lg:flex lg:justify-between lg:items-center lg:px-8 lg:h-screen">

    <!-- Sección de Texto -->
    <div class="section-text">
      <h1>Administra tus alojamientos</h1>
    </div>

    <!-- Carrusel de Imágenes -->
    <div class="relative w-full max-w-2xl lg:w-1/2 overflow-hidden rounded-lg">
      <div #slider class="flex transition-transform duration-700 ease-in-out">
        <img *ngFor="let img of images" [src]="img" class="w-full flex-shrink-0">
      </div>

      <!-- Botones de navegación -->
      <button (click)="prevSlide()" class="absolute top-1/2 left-4 -translate-y-1/2 bg-gray-800/50 p-2 rounded-full text-white">
        &#10094;
      </button>
      <button (click)="nextSlide()" class="absolute top-1/2 right-4 -translate-y-1/2 bg-gray-800/50 p-2 rounded-full text-white">
        &#10095;
      </button>
    </div>

  </div>
</section>
